(ns common.schema.entities.ai-task-config-override.permissions
  (:require [common.roles :as roles]))

(defn read-permissions?
  [{:keys [role]}]
  (roles/admin? role))

(defn disable-permissions?
  [{:keys [role tr]}]
  (when-not (roles/admin? role)
    (tr :not-allowed)))
